<script setup>
import { ref, reactive, onMounted, defineProps } from "vue";

const blockKeys = [
  "_id",
  "serialNumber",
  "licenseName",
  "__v",
  "timestamp",
  "log",
];

const displayFields = [
  { field: "customReference", display: "Session Reference" },
  { field: "eventtype", display: "Event Type" },
  {
    field: "originalCFBundleIdentifier",
    display: "Original CFBundleIdentifier",
  },
  {
    field: "originalCFBundleShortVersionString",
    display: "Original CFBundleShortVersionString",
  },
  { field: "originalCFBundleVersion", display: "Original CFBundleVersion" },
  { field: "path", display: "Path" },
  { field: "signingid", display: "Signing ID" },
  { field: "target", display: "Target" },
  { field: "username", display: "Username" },
  { field: "isplatform", display: "Apple Binary" },
  { field: "pid", display: "Process ID" },
  { field: "ppid", display: "Parent Process ID" },
  { field: "processpath", display: "Process Path" },
  { field: "xxxxx", display: "xxxx" },
];

function displayField(field) {
  const display = displayFields.find((f) => f.field === field);
  if (display) {
    return display.display;
  }
  return field;
}

const props = defineProps({
  event: Object,
});

function shouldShowField(field, value) {
  if (!value) {
    return false;
  }
  if (Array.isArray(value)) {
    return false;
  }
  if (blockKeys.includes(field)) {
    return false;
  }
  return true;
}

function arrayToString(value) {
  if (!value.length) {
    return "";
  }
  return value.join(" ");
}

onMounted(() => {
  console.log("event", props.event);
});
</script>
<template>
  <v-card variant="flat">
    <v-card-text>
      <v-table density="compact">
        <thead>
          <tr>
            <th class="text-left font-weight-bold">Event Field</th>
            <th class="text-left font-weight-bold">Event Value</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(value, field) in props.event">
            <template v-if="shouldShowField(field, value)">
              <tr :key="field">
                <th class="text-left font-weight-medium">
                  {{ displayField(field) }}
                </th>
                <td class="text-left">{{ value }}</td>
              </tr>
            </template>
            <template v-if="field == 'arguments' && value.length">
              <tr :key="field">
                <th class="text-left">Process Arguments</th>
                <td class="text-left">{{ arrayToString(value) }}</td>
              </tr>
            </template>
            <template v-if="field == 'processTree' && value.length">
              <tr :key="field">
                <th class="text-left font-weight-medium">Process Tree</th>
                <td class="text-left">
                  <v-row>
                    <v-col cols="auto">
                      <v-table density="compact">
                        <thead>
                          <tr class="font-weight-bold">
                            <th class="font-weight-bold">Name</th>
                            <th class="font-weight-bold">PID</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template
                            v-for="(process, index) in value"
                            :key="index"
                          >
                            <tr>
                              <td class="text-left">{{ process.name }}</td>
                              <td class="text-left">{{ process.pid }}</td>
                            </tr>
                          </template>
                        </tbody>
                      </v-table>
                    </v-col>
                    <v-spacer />
                  </v-row>
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </v-table>
    </v-card-text>
  </v-card>
</template>
